
import wavemill2 from '../../assets/wavemill2.jpg';    
import wavemill3 from '../../assets/wavemill3.jpg';   
import wavemill4 from '../../assets/wavemill4.jpg'; 

export default function TabConcept() {
  return (
    <div>         
      <section> 
        <p className="align_left">   
          The Wave Mill concept is based on a reciprocating air pump principle, in which oscillating seawater inside a series of rigidly connected chambers functions as a piston. <br />
          Each chamber is equipped with inlet and outlet flaps that regulate airflow. As wave crests travel along the chamber line, rising water pushes air out into the outlet duct, while falling water draws air back through the inlet duct. <br />
          <br />
          This continuous cycle converts wave motion into stable airflow in a controlled and efficient manner. An air turbine located between the inlet and outlet ducts receives unidirectional airflow and generates electrical power.<br />
          <br />
          The animation shows a wave crest passing along the Wave Mill (WM) chambers.  <br /> 
          Please pay attention to the arrows showing airflow directions.  <br /> 


        </p>  
      </section>                       
      <section>

<iframe
  src="https://www.youtube.com/embed/URCmPO_QH7s?start=103&mute=1" 
  style={{
    width: '100%',
    aspectRatio: '16 / 9',
    height: 'auto'
  }}
  allowFullScreen
></iframe>

    {/* <div className="video-wrapper">
      <iframe
        src="https://www.youtube.com/embed/URCmPO_QH7s?start=103&mute=1" 
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div> */}


        {/* <iframe 
          width="700" 
          height="600" 
          src="https://www.youtube.com/embed/URCmPO_QH7s?start=103&mute=1" 
          title="The Wave Mill animation" 
          frameborder="0" 
          allow="accelerometer; 
          autoplay; 
          clipboard-write; 
          encrypted-media; 
          gyroscope; 
          picture-in-picture; 
          web-share" allowfullscreen></iframe>    */}

      </section>                               
 
    
        <p className="align_left">    
          To improve efficiency, we installed air turbines in each air duct. <br />
          In the photos, you can see turbines in the inlet and outlet air ducts. <br />
          In the last photo, both turbines are located inside the channel connecting the inlet and outlet ducts. <br />
        </p> 

        <div style={{display: 'flex', flexWrap: 'wrap', gap: '1.2rem'}}>
          <img src={wavemill2} style={{width: '30%', height: 'auto'}} alt='' />
          <img src={wavemill3} style={{width: '30%', height: 'auto'}} alt='' />
          <img src={wavemill4} style={{width: '30%', height: 'auto'}} alt='' />
        </div>
        
        
        {/* <div class="flex_container" style={{margin: '10px'}}>  
           
            <img src={wavemill2} style={{height: '300px', objectFit: 'fill', marginRight: '10px' }} alt=''/>	
       
            <img src={wavemill3} style={{height: '300px', objectFit: 'fill', marginRight: '10px' }} alt=''/>	            	                        
        </div>

        <img src={wavemill4} style={{height: '300px', objectFit: 'fill', marginLeft: '10px' }} alt=''/> */}
        <br />
         
                                                                                 
    </div>       
  );
}